import { render } from "./InfoBeleggingen.vue?vue&type=template&id=26f80c1a&scoped=true"
import script from "./InfoBeleggingen.vue?vue&type=script&lang=js"
export * from "./InfoBeleggingen.vue?vue&type=script&lang=js"

import "./InfoBeleggingen.vue?vue&type=style&index=0&id=26f80c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f80c1a"]])

export default __exports__